import React from 'react';
import ConceptContainerVersionForm from '../common/ConceptContainerVersionForm';

const SourceVersionForm = props => <ConceptContainerVersionForm {...props} resourceType="source" />;

export default SourceVersionForm;
